import Constants from '../constants/constants';
var regex = Constants.Regex;
import moment from 'moment-timezone';

function formatTime(time) {
    const hours = Math.floor(time/60);
    const min = time%60;

    if (hours === 0) {
        return `${min} minutes`;
    } else if (hours === 1 && min > 0) {
        return `1 hour ${min} minutes`
    } else if (min === 0) {
        return `${hours} hours`;
    } else {
        return `${hours} hours ${min} minutes`;
    }
}

/**
 * checks if a formb is valid for the given user type (dispatcher or field user)
 * @param _formb
 * @param userType
 * @returns {*}
 */
function checkFormValidity(_formb, userType) {

    var _isDirty = false;//assume false unless we find a change
    var errors = [];
    var warnings = [];
    var dateRegex = new RegExp(regex.dateRegex);
    var timeRegex = new RegExp(regex.timeRegex);
    var phoneRegex = new RegExp(regex.phoneRegex);
    if (_formb.timezone == null) {
        _formb.timezone = '';
    }
    var tomorrow = moment().tz(Constants.Timezones[_formb.timezone]).add(1, 'days').hour(23).minute(59).second(59);
    var now = moment().tz(Constants.Timezones[_formb.timezone]);
    var sevenDays = moment().tz(Constants.Timezones[_formb.timezone]).add(7, 'days');
    var twelveHours = moment().tz(Constants.Timezones[_formb.timezone]).add(12, 'hours');
    var maxDate = moment().tz(Constants.Timezones[_formb.timezone]).add(-1, 'month').endOf('month').add(1, 'year');


    var startDtPresent = true, endDtPresent = true;
    if (!_formb.workStartDate || _formb.workStartDate.length === 0) {
        errors.push({ field: 'workStartDate', message: 'From Date: Please fill out this field', type: 'error' });
        startDtPresent = false;
    }
    else if (!dateRegex.test(_formb.workStartDate)) {
        _isDirty = true;
        errors.push({ field: 'workStartDate', message: 'From Date: must be in format MMddYY', type: 'error' });
        startDtPresent = false;
    }
    else
        _isDirty = true;

    if (!_formb.workStartTime || _formb.workStartTime.length === 0) {
        errors.push({ field: 'workStartTime', message: 'From Time: Please fill out this field', type: 'error' });
        startDtPresent = false;
    }
    else if (!timeRegex.test(_formb.workStartTime)) {
        _isDirty = true;
        errors.push({ field: 'workStartTime', message: 'From Time: must be in format HHmm', type: 'error' });
        startDtPresent = false;
    }
    else {
        _isDirty = true;
    }

    var validMileage = true;

    if (_formb.trackGuids.length > 0) {
        var foundStartMp = false; //There is a requirement that any guids selected must be within .1 of a mile of the start and end mp to be a valid restriction
        var foundEndMp = false;
        _formb.trackGuids.forEach(function (elem) {
            var bmp = elem.beginMp;
            var emp = elem.endMp;

            if (Math.abs(bmp - _formb.workStartMp) < .1 || Math.abs(emp - _formb.workStartMp) < .1) {
                foundStartMp = true;
            }

            if (Math.abs(bmp - _formb.workEndMp) < .1 || Math.abs(emp - _formb.workEndMp) < .1) {
                foundEndMp = true;
            }
        });

        validMileage = foundStartMp && foundEndMp;
    }

    if (!validMileage) {
        errors.push({ field: 'tracks', message: Constants.ValidationConstants.UNDERPROTECT_ERROR_MESSAGE, type: 'error' });
    }


    if (!_formb.workEndDate || _formb.workEndDate.length === 0) {
        errors.push({ field: 'workEndDate', message: 'To Date: Please fill out this field', type: 'error' });
        endDtPresent = false;
    }
    else if (!dateRegex.test(_formb.workEndDate)) {
        _isDirty = true;
        errors.push({ field: 'workEndDate', message: 'To Date: must be in format MMddYY', type: 'error' });
        endDtPresent = false;
    }
    else
        _isDirty = true;

    if (!_formb.workEndTime || _formb.workEndTime.length === 0) {
        errors.push({ field: 'workEndTime', message: 'To Time: Please fill out this field', type: 'error' });
        endDtPresent = false;
    }
    else if (!timeRegex.test(_formb.workEndTime)) {
        _isDirty = true;
        errors.push({ field: 'workEndTime', message: 'To Time: must be in format HHmm', type: 'error' });
        endDtPresent = false;
    }
    else
        _isDirty = true;

    if (startDtPresent) {
        var startDateTime = moment.tz(_formb.workStartDate + _formb.workStartTime, 'MMDDYYHHmm', Constants.Timezones[_formb.timezone]);
        if (!startDateTime.isValid()) {
            errors.push({ message: 'From Date Time is not a valid date time', field: 'workStartTime', type: 'error' })
        }
        else {

            if (userType.indexOf(Constants.Roles.DISPATCHER) > -1) {//user is a dispatcher

                //start date must be after now
                if (!now.isBefore(startDateTime)) {
                    errors.push({ field: 'workStartTime', message: 'From Date: must be in the future', type: 'error' })
                }
                else {
                    if (!twelveHours.isBefore(startDateTime)) {
                        warnings.push({
                            field: 'workStartTime',
                            message: 'From Date is less than 12 hours from now',
                            type: 'warning'
                        });
                    }
                    else if (!startDateTime.isBefore(tomorrow)) {
                        errors.push({
                            field: 'workStartTime',
                            message: 'From Date must be today or tomorrow',
                            type: 'error'
                        })
                    }
                }
            }
            else {//if no user type passed in, then default to field user status
                //must > 12 hours away
                const formBRequestThreshold = sessionStorage.getItem("formBRequestThreshold") ;
                console.log("formB threshold- ", formBRequestThreshold);

                if (!now.isBefore(startDateTime)) {
                    errors.push({ field: 'workStartTime', message: 'From Date: must be in the future', type: 'error' })
                }
                else if (!moment().tz(Constants.Timezones[_formb.timezone]).add(formBRequestThreshold, 'minutes').isBefore(startDateTime)) {
                    errors.push({
                        field: 'workStartTime',
                        message: `Start Time: must be more than ${formatTime(formBRequestThreshold)} from now`,
                        type: 'error'
                    })
                }

                //must be < 7 days away
                else if (!sevenDays.isAfter(startDateTime)) {
                    errors.push({
                        field: 'workStartTime',
                        message: 'From Date: must be less than 7 days from now',
                        type: 'error'
                    })
                }
            }
        }
    }

    if (endDtPresent) {
        var endDateTime = moment.tz(_formb.workEndDate + _formb.workEndTime, 'MMDDYYHHmm', Constants.Timezones[_formb.timezone]);

        if (!endDateTime.isValid()) {
            errors.push({ message: 'To Date Time is not a valid date time', field: 'workEndTime', type: 'error' })
        }
        else {
            if (endDateTime.isAfter(maxDate)) {
                errors.push({
                    field: 'workEndTime',
                    message: 'To Date Time: must be before ' + maxDate.format('H:Hmm MM-DD-YY'),
                    type: 'error'
                })
            }
        }


    }

    if (startDtPresent && endDtPresent) {
        //verify timespans
        var dateValidity = areDateTimeTimespanValid(_formb, userType); //return null if valid, otherwise errors
        //if (!dateValidity.isValid){
        $.each(dateValidity.errors, function (i, error) {
            errors.push(error);
        });

        $.each(dateValidity.warnings, function (i, warn) {
            warnings.push(warn);
        });
        //}
    }

    if ((!_formb.gang || _formb.gang.length === 0) && (!_formb.foremanName || _formb.foremanName.length === 0)) {

        errors.push({ field: 'gang', message: 'Gang or Foreman Name: Please fill out this field', type: 'error' })
    }
    else
        _isDirty = true;

    if ((!_formb.gang || _formb.gang.length === 0) && (!_formb.foremanName || _formb.foremanName.length === 0)) {

        errors.push({ field: 'foremanName', message: 'Gang or Foreman Name: Please fill out this field', type: 'error' })
    }
    else
        _isDirty = true;

    if (!_formb.phoneNumber || _formb.phoneNumber.length === 0) {
        if (userType.indexOf(Constants.Roles.FIELD_USER) > -1) {
            //if this is a field user, the phone number is required
            errors.push({ field: 'phoneNumber', message: 'Phone Number: Please fill out this field', type: 'error' })
        }
    }
    else if (!phoneRegex.test(_formb.phoneNumber)) {//regardless of required or not, validate it if present
        _isDirty = true;
        errors.push({ field: 'phoneNumber', message: 'Phone Number: must be in format xxx-xxx-xxxx', type: 'error' })
    }

    if (!_formb.radioChannel || _formb.radioChannel.length === 0) {
        if (userType.indexOf(Constants.Roles.FIELD_USER) > -1) {
            //if this is a field user, the radion channel is required
            errors.push({ field: 'radioChannel', message: 'Radio Channel: Please fill out this field.', type: 'error' })
        }
    }
    else
        _isDirty = true;

    if (!_formb.impedesTraffic || _formb.impedesTraffic.length === 0) {
        if (userType.indexOf(Constants.Roles.FIELD_USER) > -1) {
            errors.push({
                field: 'impedesTraffic',
                message: 'Impedes Traffic: Please fill out this field.',
                type: 'error'
            })
        }
    }
    else
        _isDirty = true;


    return { isValid: errors.length === 0, errors: errors, isDirty: _isDirty, warnings: warnings }
}

/**
 * checks whether the timespan on the formb is valid for the user type
 * assumes that all the times and dates are present
 * @param _formb
 * @param userType
 * @returns {{isValid: boolean, warnings: Array, errors: Array}}
 */
function areDateTimeTimespanValid(_formb, userType) {

    //do not call this method if any date or time input is not in a correct format (ie not blank, 4 digits, etc)
    var errors = [];
    var warnings = [];
    var formBTimeZone = '';

    if (_formb.timezone != null) {
        formBTimeZone = _formb.timezone;
    }

    var startDateTime = moment.tz(_formb.workStartDate + _formb.workStartTime, 'MMDDYYHHmm', Constants.Timezones[formBTimeZone]);
    var endDateTime = moment.tz(_formb.workEndDate + _formb.workEndTime, 'MMDDYYHHmm', Constants.Timezones[formBTimeZone]);

    if (startDateTime.isAfter(endDateTime)) {
        errors.push({ field: 'workEndTime', message: 'To Date Time: must be after From Date Time', type: 'error' })
    }


    if (startDateTime.diff(endDateTime) === 0) {
        errors.push({ field: 'workStartTime', message: 'From date and To date must be different', type: 'error' })
    }

    return { isValid: errors.length === 0, warnings: warnings, errors: errors };
}


//public api
export const formbValidation = {
    //deprecated
    checkFormValidity,
    checkDateTimeValidity: areDateTimeTimespanValid
};